import { Component, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { MultiSelect } from 'primeng/multiselect';
import { GroupAdminService } from '../../services/group-admin/group-admin.service';

@Component({
  selector: 'app-user-entitlement-checkbox',
  //templateUrl: './user-entitlement-checkbox.component.html',
  /* Jira : C153176-4323 Issue- Multiple delete actions needed to delete the user from Group Admin.*/
  template: `<p-multiSelect #role (onChange)='updateValue()' [defaultLabel]="'Choose Role'" [options]="entGrpName"
  [(ngModel)]="selectedRoleName" name="selectedRoleName" [styleClass]="'entitlement-multiselect UECheckbox multiselectUserEnt'" [style]="{'width':'100%'}" [showToggleAll]="false"
  [maxSelectedLabels]="4" [baseZIndex]="9999" [appendTo]="'body'"></p-multiSelect>`,
})
export class UserEntitlementCheckboxComponent implements ICellRendererAngularComp {
  public params: any;
  public gridRoleApi : any;
  public selectedRoleName: any[];

  private fieldname: string;
  public value: any;
  public entGrpName : any[];
  @ViewChild('role') multiselect: MultiSelect;

  constructor(private readonly groupAdminService: GroupAdminService) {}

  agInit(params: any): void {
    this.params = params;
    this.gridRoleApi = params.api;
    this.fieldname = params.fieldname;
    this.entGrpName = [
      { label: 'Group Admin', value: 'Group Admin' },
      { label: 'Peer Reviewer', value: 'Peer Reviewer' },
      { label: 'Supervisor', value: 'Supervisor' },
      { label: 'Analyst', value: 'Analyst' }
    ];

    if (this.params.value == null || this.params.value === '') {
      this.selectedRoleName = [];
    } else {
      this.selectedRoleName = (this.params.value).split(',');
      this.selectedRoleName = this.selectedRoleName.map(function (el) {
        return el.trim();
      });
    }
  }

  updateValue() {
    this.params.data.role = this.getValue();
    this.groupAdminService.setUnsavedChanges(true);
  }
  getValue(): string {
    if (this.selectedRoleName?.length > 0) {
      return this.selectedRoleName.join();
    }
    return '';
  }

  refresh(): boolean {
      return true;
  }

}
